<template>
	<div>
		<a-modal v-show='ishand' id='dangr' width='60rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">當日成交</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="max-height: 500px;padding-top: 2.8rem;">
				<div id='min-list'>
					<a-table style="width:100%;" :columns="columore" :data-source="moreDatas" id='fromtable2'
					:scroll="{ y: 350 }"
						:pagination="false">
						<div slot='bs_flag' slot-scope='record' >
							<span v-if="record.bs_flag=='B'" style="color: #11c3ff;">買入</span>
							<span v-else style="color: #ff0303;">沽出</span>
						</div>
					</a-table>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: ['openstatic'],
		data() {
			return {
				visible: true,
				ishand: true,
				columore: [
					{
					title: '買/沽',
					// dataIndex: '', //B買入or賣出
					sorter: true,
					align: 'center',
					width: '13%',
					slots: {
						title: 'alltext'
					},
					scopedSlots: {
						customRender: 'bs_flag'
					}
				}, {
					title: '市場',
					sorter: true,
					dataIndex: 'exchange_code',
					align: 'center',
					width: '13%',
				}, {
					title: '產品名稱',
					sorter: true,
					dataIndex: 'product_name',
					align: 'center',
					width: '15%',
				}, {
					title: '股票編號',
					sorter: true,
					dataIndex: 'product_code',
					align: 'center',
					width: '15%',
				}, {
					title: '成交平均價',
					sorter: true,
					dataIndex: 'exec_price',
					align: 'center',
					width: '15%',
				}, {
					title: '數量',
					sorter: true,
					dataIndex: 'exec_qty',
					align: 'center',
					width: '13%',
				}, {
					title: '金額',
					sorter: true,
					dataIndex: 'exec_amt',
					align: 'center',
					width: 'auto',
				}],
				moreDatas: [],
			}
		},
		mounted() {
			this.postdata()
		},
		methods: {
			fanjiebao(val,to=2,num=1){
				//金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
				      var str = (val/num).toFixed(to) + '';
				      var intSum = str.substring(0,str.indexOf(".")).replace( /\B(?=(?:\d{3})+$)/g, ',' );//取到整数部分
				      var dot = str.substring(str.length,str.indexOf("."))//取到小数部分搜索
				      var ret = intSum + dot;
				      return ret;
				    //输出结果->20,000.00
			},
			uuid() {
				var s = [];
				var hexDigits = "0123456789abcdef";
				for (var i = 0; i < 36; i++) {
					s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				}
				s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
				s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
				s[8] = s[13] = s[18] = s[23] = "-";
				var uuid = s.join("");
				return uuid;
			},
			postdata() {
				let datanow = new Date().toLocaleDateString().split('/')
				
				let obj = {
					client_acc_code: '1000005',
					localized_name: 'Y',
					from_trade_date:'2021-03-01',
					order_status:"FEX",
					to_trade_date:datanow.join('-'),
				}
				
				// for(let key in obj){
				
				// }
				let uuid = this.uuid()
				this.$ajax({
					method: 'post',
					// url: this.$api.adminurls,
					url : this.$api.multiOrder,
					// contentType: '',
					// data: {
					// 	command: this.$axoisfix('multi_order', obj, uuid),
					// 	language: 'big5',
					// 	msgnum: uuid,
					// 	token: "daca4cca-f334-4c26-8165-3f8d583e17fe",
					// 	username: 1000005,
					// }
					data:{
						token : this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						// App.oTool.successT();
						// 取出 order_status PEX FEX 显示
						let  moreDatas = []
						// if (res.data.message.order) {
							// if (res.data.message.order.constructor === Array) {
							// 	moreDatas = res.data.message.order
							// } else if (res.data.message.order.constructor === Object) {
							// 	moreDatas = [res.data.message.order]
							// }
						// }
						if(res.data.qmiscode == 1000){
							moreDatas = res.data.order
						}
						//获取hkd的汇率
						moreDatas.map(ev=>{
							// if(ev.order_status == 'PEX'||ev.order_status == 'FEX'){
								ev.exec_price = this.fanjiebao(ev.exec_price)//.split('.')[0]
								ev.exec_amt = this.fanjiebao(ev.exec_amt)//.split('.')[0]
								ev.exec_qty = this.fanjiebao(ev.exec_qty).split('.')[0]
								
								this.moreDatas.push(ev)
							// }
						})
					} else {
						// App.oTool.warningT(res.data.qmismsg);
					}
					
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			},
		}
	}
</script>

<style lang="scss" scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.ckedf {
		background-color: #0c8b97;
		position: absolute;
		top: 1px;
		left: 0;
		color: #fff;
		width: 11.1rem;
		height: 52.8px;
		line-height: 52.8px;
	}
	.ckedfx {
		background-color: #fff;
		position: absolute;
		top: 1px;
		left: 2px;
		width: 11.1rem;
		height: 52.8px;
		line-height: 52.8px;
	}

	.ckedf1 {
		background-color: #0c8b97;
		position: absolute;
		top: 1px;
		right: 0;
		color: #fff;
		width: 7.5rem;
		height: 52.8px;
		line-height: 52.8px;
	}
	.ckedfs {
		background-color: #fff;
		position: absolute;
		top: 1px;
		right: 2px;
		width: 7.5rem;
		height: 52.8px;//2.79rem
		line-height: 52.8px;
	}

	.mark {
		margin-top: 1rem;
		background-color: #0c8b97;

		div {
			width: 7rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
			text-align: center;
			color: #fff;
		}
	}
</style>
<style lang="scss">
	.warp-abv{
		    background: #fff;
		    border: 1px solid #d8d8d8;
			height: 2rem;
			line-height: 2rem;
			cursor: pointer;
			color: #000 !important;
	}
	.centerdiv{
		border-top: 0;
		border-bottom:0 ;
	}
	.warp-abv:hover{
		background-color: #5cb1b9;
	}
	#dangr {
		.ant-modal-header,
		.ant-modal-body {
			background-color: #fff !important;
		}
		.ant-modal {
			top: 20vh;
		}
		.ant-table-body, .ant-table-content{
			border-left: .5px solid #e8e8e8;
			border-top: .5px solid #e8e8e8;
			border-right: .5px solid #e8e8e8;
		}
		.ant-table-placeholder{
			border-left: .5px solid #e8e8e8;
			border-right: .5px solid #e8e8e8;
		}
		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem
			}
		}

		.ant-table-column-title {
			font-weight: 600;
		}

		.ant-table-row-cell-break-word {
			color: #000;
		}

		#min-list {

			.ant-table-thead>tr>th,
			.ant-table-tbody>tr>td {
				padding: 16px 0;
			}
		}

		.ant-table-header-column {
			.ant-table-column-title {
				font-size: 0.85rem;
			}
		}
		.ant-modal-content {
			border-radius: 10px !important;
		}
	}
</style>
